module.exports = __webpack_public_path__ + "static/adidas-orizziontale-7f17f810f4255e764d8c4383ae074825.jpg";